<div class="container">
  <div class="title">Relance de disponibilités</div>
  <div *ngIf="popupLoading" fxLayout="row" fxLayoutAlign="center center">
    <mat-spinner diameter="60"></mat-spinner>
  </div>
  <form *ngIf="formGroup" class="body" fxLayout="column" fxLayoutAlign="start stretch">
    <div fxLayout="row">
      <app-range-date-picker
        class="width-210"
        [showArrows]="false"
        (SelectedDates)="dateChange($event)"
        [sideOpening]="'right'"
        [hasDefaultRanges]="true"
        [hasFuturRanges]="true"
      ></app-range-date-picker>
    </div>

    <app-checkbox-group
      *ngIf="isNurse"
      label="Poste"
      [formCtrl]="formGroup.get('position')"
      [elements]="$any(profilesPositions)"
      layout="row wrap"
    ></app-checkbox-group>

    <div *ngIf="!isNurse" class="width-210 default-select" layout="row">
      <div class="select-label">Poste :</div>
      <div class="select-container">
        <select [formControl]="formGroup.get('position')" required>
          <option *ngFor="let position of profilesPositions" [value]="position.value">
            {{ position.label }}
          </option>
        </select>
      </div>
    </div>

    <app-checkbox-group
      label="Statut"
      [formCtrl]="formGroup.get('residency')"
      layout="row"
      [elements]="residencies"
    ></app-checkbox-group>

    <!-- seniority -->
    <app-checkbox-group
      *ngIf="showSeniority"
      label="Séniorité"
      layout="row"
      [elements]="seniorities"
      [formCtrl]="formGroup.get('seniority')"
    >
    </app-checkbox-group>

    <!-- service -->
    <div class="default-select" *ngIf="isMultiHospitals">
      <div class="select-label">Service</div>
      <div class="select-container select-container-service">
        <select
          [formControl]="formGroup.get('hospitals')"
          (ngModelChange)="onChangeService()"
          required
          style="
            padding: 0 32px 0 8px !important;
            -webkit-padding-end: 32px !important;
            -webkit-padding-start: 8px !important;
          "
        >
          <option *ngFor="let hospital of hospitals" [ngValue]="hospital">
            <!-- {{ hospital.name }} -->
            {{ hospital.displayName }}
          </option>
        </select>
      </div>
    </div>

    <!-- targeted relaunch -->
    <mat-slide-toggle layout="row" [formControl]="formGroup.get('targeted')">Relance ciblée</mat-slide-toggle>
    <div *ngIf="isNurse || chosenPosition.includes('Iade') ? targeted : targeted && showSeniority" layout="row">
      <!-- Competences filter -->
      <!-- <br><mat-slide-toggle *ngIf="!chosenPosition.includes('Iade') " [formControl]="formGroup.get('competenceFilter')">{{isNurse ?'Filtre de compétences':'Choisir le secteur'}}</mat-slide-toggle> -->
      <br /><mat-slide-toggle [formControl]="formGroup.get('competenceFilter')">{{
        isNurse ? 'Filtre de compétences' : 'Choisir le secteur'
      }}</mat-slide-toggle>

      <div *ngIf="competenceFilter">
        <!-- competence -->
        <div class="width-240 default-select mt-10" layout="row">
          <div class="select-label">{{ hospitalNames.specialtiesName }} :</div>
          <div class="select-container">
            <select [formControl]="formGroup.get('specialty')">
              <option *ngFor="let specialty of specialties" [value]="specialty._id">
                {{ specialty.name }}
              </option>
            </select>
          </div>
        </div>
        <!-- Aide Op || Circulante -->
        <div *ngIf="showRole" class="width-240 default-select mt-10">
          <div *ngIf="isNurse; else isNotNurses">
            <div class="select-label">Rôle :</div>
            <div class="select-container">
              <select [formControl]="formGroup.get('typeInf')">
                <option *ngFor="let type of typeInfOptions" [value]="type.value">
                  {{ type.label }}
                </option>
              </select>
            </div>
          </div>
          <ng-template #isNotNurses>
            <div class="select-label" *ngIf="!chosenPosition.includes('Iade')">Type :</div>
            <div class="select-container">
              <select [formControl]="formGroup.get('typeAnesth')">
                <option *ngFor="let type of typeAnesthOptions" [value]="type.value">
                  {{ type.label }}
                </option>
              </select>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <div *ngIf="targeted">
      <div *ngIf="!loadingProfiles" class="width-150 default-select">
        <br />
        <div class="profiles-label-container">
          <div class="select-label profiles-label">Collaborateurs proposés :</div>
          <div class="select-all-checkbox">
            <mat-slide-toggle [formControl]="formGroup.get('selectAllProfiles')">Sélectionner tous</mat-slide-toggle>
          </div>
        </div>
        <br />

        <div class="profiles-box" *ngIf="filteredProfiles.length > 0; else noProfile">
          <div
            *ngFor="let profile of competenceFilter ? filteredProfiles.slice(0, 10) : filteredProfiles; let i = index"
            class="profile-box"
          >
            <mat-checkbox
              *ngIf="competenceFilter"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="profile.checked"
              (change)="changeSelectAllState()"
              [disabled]="!profile.haveUser"
              >{{ i + 1 }} - {{ toPascalCase(profile.firstName) }} - {{ toPascalCase(profile.lastName)
              }}{{ !profile.haveUser ? ' (sans compte)' : ''
              }}{{
                !isNurse && showSeniority && chosenSeniorities.length > 1
                  ? ' - ' + (profile.seniority | formatSeniority)
                  : ''
              }}
            </mat-checkbox>
            <mat-checkbox
              *ngIf="!competenceFilter"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="profile.checked"
              (change)="changeSelectAllState()"
              [disabled]="!profile.haveUser"
              >{{ toPascalCase(profile.firstName) }} - {{ toPascalCase(profile.lastName)
              }}{{ !profile.haveUser ? ' (sans compte)' : ''
              }}{{
                !isNurse && showSeniority && chosenSeniorities.length > 1
                  ? ' - ' + (profile.seniority | formatSeniority)
                  : ''
              }}
            </mat-checkbox>
          </div>
        </div>
        <ng-template #noProfile>
          <p>Aucun profil trouvé</p>
        </ng-template>
      </div>
      <div *ngIf="loadingProfiles" fxLayout="row" fxLayoutAlign="center center">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
    </div>

    <div [ngClass]="{ 'competence-filter-off': !competenceFilter }">
      <div class="input-name">Message libre</div>
      <quill-editor [styles]="{ height: '200px' }" (onEditorChanged)="changedEditor($event)"></quill-editor>
    </div>
  </form>

  <div *ngIf="formGroup" class="buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-button text="Annuler" btnType="text" (click)="close()"></app-button>
    <app-button
      text="Relancer"
      (click)="save()"
      [matTooltip]="saveButtonTooltip"
      [matTooltipDisabled]="$any(!formGroup.valid || isDateValid || disabled)"
      [disabled]="!seniorityValid || !formGroup.valid || !isDateValid || disabled"
      [isSpinning]="isSpinning"
      [isSpinner]="true"
    ></app-button>
  </div>
</div>
